// extracted by mini-css-extract-plugin
export default {"titleBox":"MainTitle_titleBox__GKKWM"};